export function renderTitle({ type = 1, listItens = [] }) {
    const toSeparate = listItens.filter((item) => item.fgSeparado === 0);

    if (type) {
        return toSeparate.length
            ? `Ops... ${toSeparate.length} ${
                  toSeparate.length === 1
                      ? 'produto não foi separado'
                      : 'produtos não foram separados'
              }`
            : `Deseja separar esse pedido?`;
    }

    return toSeparate.length
        ? 'Deseja separar o pedido mesmo assim?'
        : 'Não é possível alterar os produtos do pedido após a separação.';
}
